<template>
  <div>
    <!-- MisPagosView -->
  </div>
</template>

<script>
export default {
  name: 'MisPagosView'
}
</script>



// WEBPACK FOOTER //
// src/views/clientes/MisPagosView.vue